import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { Option } from 'owa-options-core';

import * as React from 'react';
const styles = require('./OptionsFull.scss');

export interface OptionsFormProps {
    option: Option;
}

const OptionsForm = observer(
    function OptionsForm(props: OptionsFormProps, ref: React.Ref<HTMLDivElement>) {
        let { option } = props;
        let { fullOptionFormSettings, key, titleStringKey, hideTitleInFullOptions, icon } = option;

        if (!fullOptionFormSettings) {
            return null;
        }
        let optionAriaId = `options-full-${key}`;

        return (
            <div className={styles.optionEntry} ref={ref}>
                {!hideTitleInFullOptions && (
                    <div className={styles.header} role="heading" aria-level={4}>
                        <span className={styles.title} id={optionAriaId}>
                            {loc(titleStringKey)}
                        </span>
                        {icon ? <img className={styles.titleLogo} src={icon} /> : null}
                    </div>
                )}
                <div className={styles.formContainer} aria-labelledby={optionAriaId}>
                    {fullOptionFormSettings.render()}
                </div>
            </div>
        );
    },
    { forwardRef: true }
);
export default OptionsForm;
